import { ApplicationStatus, StatusOverride } from '@bybeam/platform-types';

export const DEFAULT_STATUSES: {
  [status in ApplicationStatus]: Pick<StatusOverride, 'label' | 'message'>;
} = {
  Application: {
    label: 'Apply for emergency assistance',
    message:
      'You could be found eligible to receive cash assistance up to {MAX_AMOUNT}. These funds do not require repayment and are intended to help people who are in high need of financial assistance.',
  },
  Approved: {
    label: 'Status: Application Decision',
    message:
      'You are approved to receive {APPROVED_AMOUNT}. A member of {PARTNER_NAME}’s staff will follow up with you on how you will receive these funds.',
  },
  Denied: {
    label: 'Status: Application Decision',
    message:
      'Unfortunately, {PARTNER_NAME} is unable to provide you with funds at this time. If you have any questions about this decision, you can contact {PARTNER_NAME} at {PARTNER_EMAIL} or {PARTNER_PHONE}.',
  },
  AwaitingReview: {
    label: 'Status: Awaiting Review',
    message:
      'Thank you for submitting your application! You will be notified once a case manager is assigned to review your application. Check back here for updates.',
  },
  InReview: {
    label: 'Status: In Review',
    message:
      'We’re currently reviewing your application and will reach a decision shortly. You’ll receive an email once a decision has been made and no further action is required on your part.',
  },
  InProgress: {
    label: 'Continue where you left off',
    message:
      'You’ve made great progress so far! Keep working on your application to receive emergency assistance for your household needs.',
  },
  Incomplete: {
    label: 'Continue Application',
    message: 'Your application is missing information.',
  },
  WithdrawnOpen: {
    label: 'Status: Withdrawn',
    message:
      'Your application was withdrawn due to inactivity. However, you can pick back up where you left off and submit your application. Please complete your application quickly so you can receive an eligibility determination sooner rather than later.',
  },
  WithdrawnClosed: {
    label: 'Status: Withdrawn',
    message:
      "Your application was withdrawn due to inactivity. If you'd like to resume your application, contact your case manager.",
  },
  Unknown: {
    label: 'Unknown',
    message: 'There was an error retrieving the status of your application.',
  },
};
